<template>
  <section ref="baseDropdown" class="base-dropdown" @blur="isActive = false">
    <BaseButton
      type="button"
      class="base-dropdown__button"
      :class="psuedoIcon ? 'psuedo-icon' : ''"
      :color="buttonColor"
      :text-color="buttonTextColor"
      :size="buttonSize"
      :button-style="buttonStyle"
      @click="isActive = !isActive"
      @blur="handleButtonBlur()"
      :disabled="disabled"
    >
      <slot name="button" />
      <div v-if="altIcon" class="base-dropdown__alt-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
        >
          <path
            d="M7.94531 0.554688L4.95117 7.04883L3.9668 7.04883L0.583008 0.554687L2.2168 0.554688L4.41797 4.9502L6.33203 0.554688H7.94531Z"
            fill="#585B60"
          />
        </svg>
      </div>
      <IconChevronDown
        v-if="!altIcon && !psuedoIcon"
        :is-active="isActive"
        :color="iconFill"
        :is-solid="iconSolid"
        :width="iconSolid ? 10 : null"
        :height="iconSolid ? 10 : null"
      />
    </BaseButton>
    <div
      class="base-dropdown__list-container"
      :class="[
        `base-dropdown__list-container--menu-color-${menuColor}`,
        `base-dropdown__list-container--from-${veritcalPosition}`,
        `base-dropdown__list-container--from-${horizontalPosition}`,
        {
          'base-dropdown__list-container--active': isActive,
          'base-dropdown__list-container--border': menuBorder,
        },
      ]"
    >
      <ul
        class="base-dropdown__list"
        @mousedown="isBluring = false"
        @mouseup="handleMouseUp()"
      >
        <slot name="options" />
      </ul>
    </div>
  </section>
</template>

<script>
  import BaseButton from './BaseButton.vue';
  import IconChevronDown from '~/components/icon/IconChevronDown.vue';

  export default {
    name: 'BaseDropdown',
    components: { BaseButton, IconChevronDown },
    props: {
      buttonStyle: {
        type: String,
        required: false,
        default: 'flat',
        validator: (value) => {
          const STYLES = ['normal', 'flat'];
          return STYLES.includes(value);
        },
      },
      buttonColor: {
        type: String,
        required: false,
        default: 'grey',
        validator: (value) => {
          const COLORS = [
            'primary',
            'secondary',
            'cta',
            'success',
            'warning',
            'danger',
            'grey',
            'dark-grey',
            'charcoal',
            'green',
            'green-mid',
            'white',
            'black',
          ];
          return COLORS.includes(value);
        },
      },
      buttonTextColor: {
        type: String,
        required: false,
        default: 'charcoal',
        validator: (value) => {
          const COLORS = [
            'primary',
            'secondary',
            'cta',
            'success',
            'warning',
            'danger',
            'grey',
            'dark-grey',
            'charcoal',
            'green',
            'green-mid',
            'white',
            'black',
          ];
          return COLORS.includes(value);
        },
      },
      menuColor: {
        type: String,
        required: false,
        default: 'grey',
        validator: (value) => {
          const COLORS = ['grey', 'white', 'black'];
          return COLORS.includes(value);
        },
      },
      menuBorder: Boolean,
      buttonSize: {
        type: String,
        required: false,
        default: 'flat',
        validator: (value) => {
          const SIZES = ['xs', 'sm', 'md', 'lg', 'xl', 'flat'];
          return SIZES.includes(value);
        },
      },
      iconFill: {
        type: String,
        required: false,
        default: 'charcoal',
        validator: (value) => {
          const COLORS = [
            'primary',
            'secondary',
            'cta',
            'success',
            'warning',
            'danger',
            'grey',
            'dark-grey',
            'charcoal',
            'green',
            'green-mid',
            'white',
            'black',
          ];
          return COLORS.includes(value);
        },
      },
      iconSolid: Boolean,
      altIcon: Boolean,
      psuedoIcon: Boolean,
      disabled: Boolean,
    },
    data: () => ({
      isActive: false,
      isBluring: true,
    }),
    computed: {
      veritcalPosition() {
        if (!this.$refs?.baseDropdown) return 'bottom';
        const domElement = this.$refs.baseDropdown;
        const { top, bottom } = domElement.getBoundingClientRect();
        const { innerHeight } = window;
        const isBottom = bottom > innerHeight;

        return isBottom ? 'bottom' : 'top';
      },
      horizontalPosition() {
        // TODO: MAKE THIS DYNAMIC IF NEEDED
        return 'right';
      },
    },
    methods: {
      handleButtonBlur() {
        setTimeout(() => {
          if (this.isBluring) {
            this.isActive = false;
            return;
          }
          this.isActive = true;
        }, 50);
      },
      handleMouseUp() {
        this.isBluring = true;
        this.isActive = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .base-dropdown {
    position: relative;
    z-index: 100;
    width: fit-content;

    &__button {
      display: flex;
      align-items: center;
      z-index: 2;
      gap: 4px;
    }
    &__alt-icon {
      margin-left: 8px;
    }
    &__list-container {
      opacity: 0;
      display: none;
      visibility: hidden;
      position: absolute;

      overflow: hidden;
      padding: 0;
      margin: 0;
      // min-width: 100%;

      max-height: 80vh;
      overflow-x: hidden;
      overflow-y: auto;

      transform: translateY(-25%);
      transition: all 300ms ease-in-out;

      z-index: 1;

      border-radius: 3px;

      &--from-top {
        top: auto;
        bottom: 100%;
        // transform: translateY(25%);
      }

      &--from-bottom {
        top: 100%;
        bottom: auto;
        // transform: translateY(-25%);
      }

      &--from-left {
        left: 0;
        right: auto;
        // transform: translateX(-25%);
      }

      &--from-right {
        left: auto;
        right: 0;
        // transform: translateX(25%);
      }

      &--active {
        opacity: 1;
        display: block;
        visibility: visible;
        transform: translateY(0);
        transition: all 300ms ease-in-out;
        z-index: -1;
      }

      &--menu-color-grey {
        color: #111;
        background-color: rgb(240, 240, 240);
        box-shadow: 1px 3px 5px rgba($black, 0.25);

        li button:hover {
          background-color: darken(rgb(240, 240, 240), 15%);
        }
      }
      &--menu-color-white {
        color: #111;
        background-color: #fff;
        box-shadow: 1px 3px 5px rgba($black, 0.25);

        li button:hover {
          background-color: darken(#fff, 15%);
        }
      }
      &--menu-color-black {
        color: #fff;
        background-color: #111;
        box-shadow: 1px 3px 5px rgba($black, 0.25);

        li button:hover {
          background-color: lighten(#111, 15%);
        }
      }

      &--border {
        border: 1px solid var(--itr-grey-mid);
      }
    }
    &__list {
      position: relative;
      padding: 5px;
      margin: 0;
      list-style: none;
      z-index: 0;

      background-color: inherit;

      :deep(li) {
        min-width: 192px;
        max-width: 100%;
        width: 100%;

        background-color: inherit;

        button {
          padding: 5px 10px 5px 5px;
          margin: 0;
          cursor: pointer;
          transition: all 300ms ease-in-out;
          width: 100%;
          background-color: var(--itr-white);
          text-align: left;
        }
      }
    }
  }
  .psuedo-icon {
    width: 150px;
    &::before {
      position: absolute;
      top: 10px;
      right: 20px;
      color: var(--itr-white);
      content: '\E909';
      display: inline-block;
      font-family: icomoon !important;
      font-size: 5px;
      font-weight: 400;
      transition: transform 0.33s;
    }
  }
</style>
